// extracted by mini-css-extract-plugin
module.exports = {"modalTermos":"style_modalTermos__1vZl-","ant-modal-content":"style_ant-modal-content__2plh4"};